import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { IBeneficios2Props } from '../beneficios2';

function beneficios2Adapter(data: any): IBeneficios2Props {
    return {
        title: data.tituloGeneral.split(';')[1],
        subtitle: data.tituloGeneral.split(';')[0],
        description: documentToReactComponents(JSON.parse(data.descripcion.raw)),
        image: data.imagenPrincipal.file.url,
        cards:
            data?.referenciaPlantillaContenido?.map((card: any) => ({
                title: card.tituloBanner,
                description: documentToReactComponents(JSON.parse(card.descripcion.raw)),
                icon: card.tituloDescripcion
                    ? card.tituloDescripcion
                    : 'icon-plus-thin',
            })) ?? [],
    };
}

export default beneficios2Adapter;
